// presentFXRates transforms foreign exchange rate response from the API into an array
export default function (response) {
  const ratesList = {};
  response.results.forEach((rate) => {
    ratesList[rate.currencyCode] = rate.rate;
  });
  return ratesList;
}
